/* src/app/layouts/authenticated/authenticated.component.css */
mat-toolbar-row:nth-child(1),
mat-sidenav-content div:nth-child(1) {
  -webkit-box-shadow: 0px 2px 10px 2px rgba(0, 0, 0, 0.3);
  -moz-box-shadow: 0px 2px 10px 2px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 2px 10px 2px rgba(0, 0, 0, 0.3);
}
.mobile {
  display: none;
}
.not-mobile {
  display: block;
}
.new {
  float: right;
  font-size: 36px;
  margin-right: 10px;
  -webkit-animation: flickerAnimation 3s infinite;
  -moz-animation: flickerAnimation 3s infinite;
  -o-animation: flickerAnimation 3s infinite;
  animation: flickerAnimation 3s infinite;
}
@media screen and (max-width: 500px) {
  .mobile {
    display: block;
  }
  .not-mobile {
    display: none;
  }
}
@keyframes flickerAnimation {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@-o-keyframes flickerAnimation {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@-moz-keyframes flickerAnimation {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@-webkit-keyframes flickerAnimation {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.mat-subtitle-1 {
  color: #FFFFFF;
}
.division-name {
  padding: 0;
  font-size: 16px;
}
/*# sourceMappingURL=authenticated.component-O6EFBWY7.css.map */
